export const myCourse = {
    "no_course_yet" : "Chưa có khóa học nào",
};
